import React, { useContext, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ThemeContext } from '../../ThemeContext';
import './footer.scss';
import companyLogoLight from './../../assets/footerlight.png';
import companyLogoDark from './../../assets/footerdark.png';
import ContactModal from './../ContactModal';
import {
  FaXTwitter,
  FaDiscord,
  FaInstagram,
  FaLinkedin,
} from 'react-icons/fa6';
import { PRIVACY_URL, TERMS_URL } from '../../utils/urls';

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <footer
      className={`footer ${theme === 'dark' ? 'footer-dark' : 'footer-light'}`}
    >
      <Container>
        <Row className="footer-main">
          {/* Company Info Section */}
          <Col lg={4} md={12} className="mb-4 mb-lg-0">
            <div className="company-section">
              <div className="powered-by mb-3">
                <span className="powered-text">Powered by</span>
                <img
                  src={theme === 'dark' ? companyLogoDark : companyLogoLight}
                  alt="MindMade logo"
                  className="company-logo mb-3"
                />
              </div>
              <p className="company-description">
                Crafting innovative solutions with cutting-edge technology and
                creative excellence.
              </p>
            </div>
          </Col>

          {/* Quick Links Section */}
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <div className="links-section">
              <h5 className="section-title">Quick Links</h5>
              <ul className="footer-links">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/Download">Download</a>
                </li>
                <li>
                  <a href="/Faq">Pricing</a>
                </li>
                <li>
                  <a href="/Docs">Docs</a>
                </li>
                <li>
                  <button
                    className="link-button"
                    onClick={() => setShowContactModal(true)}
                  >
                    Contact Us
                  </button>
                </li>
              </ul>
            </div>
          </Col>

          {/* Connect Section */}
          <Col lg={4} md={6}>
            <div className="social-section">
              <h5 className="section-title">Connect With Us</h5>
              <div className="social-icons">
                <a
                  href="https://x.com/MindMadeLab"
                  className="social-link"
                  aria-label="Twitter"
                >
                  <FaXTwitter />
                </a>
                <a
                  href="https://discord.gg/YQqTNQPM"
                  className="social-link"
                  aria-label="Discord"
                >
                  <FaDiscord />
                </a>
                {/* <a href="#" className="social-link" aria-label="Instagram">
      <FaInstagram />
    </a> */}
                {/* <a href="#" className="social-link" aria-label="LinkedIn">
      <FaLinkedin />
    </a> */}
              </div>
            </div>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <Row className="footer-bottom">
          <Col className="text-center">
            <hr className="footer-divider" />
            <div className="footer-copyright">
              <span>
                © {new Date().getFullYear()} MindMade. All rights reserved.
              </span>
              <div className="legal-links">
                <a href={PRIVACY_URL}>Privacy Policy</a>
                <a href={TERMS_URL}>Terms of Service</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <ContactModal
        show={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    </footer>
  );
};

export default Footer;
